module.exports = "<sq-administration class=\"flexRowContainer flexFill\"></sq-administration>\n\n";